import PropTypes from 'prop-types'
import { Footer } from '../../layout/footer'
import { Responsive } from '../Responsive'
import { Element } from '../html/element'
import { Loading } from '../loading'
import { ScrollComponent } from '../scrollComponent'
import { Horizontal } from './horizontal'
import classes from './index.module.scss'
import { Vertical } from './vertical'

export const SideBar = ({
  list,
  renderTopComponent,
  renderBottomComponent,
  renderStickyComponent,
  renderFooter,
  isResponsive,
  isShowSideBarWhenResponsive,
  isShowFooter,
  scrollId,
  isLoadingContent,
  headerStyle,
  contentStyle,
}) => {
  const renderResponsive = () => {
    return (
      <div className="wh100 flexColumn">
        <div className={classes.header} style={headerStyle}>
          {renderTopComponent()}
          {isShowSideBarWhenResponsive && <Horizontal list={list} />}
          {!isLoadingContent && renderStickyComponent()}
        </div>
        {renderContent()}
      </div>
    )
  }

  const renderContentResponsive = () => {
    return (
      <>
        <Vertical list={list} />
        <div className="flex1 minW0">
          <div className="h100 flexColumn">
            <div className={classes.header} style={headerStyle}>
              {renderTopComponent()}
              {!isLoadingContent && renderStickyComponent()}
            </div>

            {renderContent()}
          </div>
        </div>
      </>
    )
  }

  const renderContent = () => {
    return (
      <div id={scrollId} className="flex1 positionRelative">
        {isLoadingContent && (
          <Loading style={{ backgroundColor: '#ffffff', zIndex: 1 }} />
        )}
        <ScrollComponent id={scrollId}>
          <div className={'flexColumn h100'}>
            <div
              className={`${classes.center} ${
                renderFooter || isShowFooter ? 'flex1' : 'h100'
              } positionRelative`}
              style={contentStyle}
            >
              {renderBottomComponent()}
            </div>

            <div>
              {renderFooter && renderFooter()}
              {isShowFooter && <Footer />}
            </div>
          </div>
        </ScrollComponent>
      </div>
    )
  }

  return (
    <Element className={classes.container}>
      {isResponsive ? (
        <Responsive renderResponsive={renderResponsive}>
          {renderContentResponsive()}
        </Responsive>
      ) : (
        renderContentResponsive()
      )}
    </Element>
  )
}

SideBar.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isI18n: PropTypes.bool,
      route: PropTypes.string,
    }),
  ),
  renderTopComponent: PropTypes.func,
  renderBottomComponent: PropTypes.func,
  renderStickyComponent: PropTypes.func,
  renderFooter: PropTypes.func,
  isResponsive: PropTypes.bool,
  isShowSideBarWhenResponsive: PropTypes.bool,
  isShowFooter: PropTypes.bool,
  scrollId: PropTypes.string,
  isLoadingContent: PropTypes.bool,
  contentStyle: PropTypes.object,
  headerStyle: PropTypes.object,
}

SideBar.defaultProps = {
  renderTopComponent: () => {},
  renderBottomComponent: () => {},
  renderStickyComponent: () => {},
  isResponsive: true,
  isShowSideBarWhenResponsive: true,
  isShowFooter: true,
  isLoadingContent: false,
  headerStyle: {},
  contentStyle: {},
}
